import { FC, ReactNode } from 'react';
import { styled } from '@mui/material';

const StyledList = styled('div', {
  name: 'SidebarMenu',
  slot: 'list',
})(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export interface ListProps {
  children: ReactNode;
}

const List: FC<ListProps> = (props) => {
  return <StyledList {...props} />;
};

List.displayName = 'SidebarMenu.List';

export default List;
